var React = require('react');

function Instagram (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M0 7.67C0 3.435 3.411 0 7.614 0H17.2c4.205 0 7.614 3.437 7.614 7.67v9.66c0 4.236-3.411 7.67-7.614 7.67H7.614C3.409 25 0 21.563 0 17.33V7.67zm2.256 0v9.66c0 2.979 2.4 5.397 5.358 5.397H17.2c2.958 0 5.358-2.417 5.358-5.398V7.671c0-2.98-2.4-5.398-5.358-5.398H7.614c-2.958 0-5.358 2.417-5.358 5.398zm10.151 11.364c-3.582 0-6.485-2.925-6.485-6.534s2.903-6.534 6.485-6.534c3.582 0 6.485 2.925 6.485 6.534s-2.903 6.534-6.485 6.534zm0-2.273c2.336 0 4.23-1.908 4.23-4.261s-1.894-4.261-4.23-4.261c-2.336 0-4.23 1.908-4.23 4.261s1.894 4.261 4.23 4.261zm6.626-9.375c-.856 0-1.55-.7-1.55-1.562 0-.863.694-1.563 1.55-1.563.857 0 1.551.7 1.551 1.563s-.694 1.562-1.55 1.562z"}));
}

Instagram.displayName = "Instagram";

Instagram.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = Instagram;

Instagram.default = Instagram;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/instagram.svg
// module id = 1272
// module chunks = 0